<template>
    <div>
        <b-row
            ><b-col> <h4 class="page-title">Create Criteria</h4></b-col
            ><b-col>
                <router-link to="/listOfCriteria">
                    <eb-button
                        class="back-btn-right"
                        classic="btn-success"
                        text="Back"
                    />
                </router-link>
            </b-col>
        </b-row>

        <b-card>
            <h5 class="text-primary">Criteria Selection</h5>
            <b-row>
                <b-col md="3">
                    <ev-select
                        disabled
                        class="select-background-white"
                        id="text"
                        type="text"
                        label="text"
                        placeholder="Select Criteria"
                        :options="criteriaOptions"
                        v-model="selectedCriteriaOptions"
                        :selected="selectedCriteriaOptions"
                    >
                    </ev-select>
                </b-col>
            </b-row>

            <b-row
                v-for="(option, index) in selectedCriteriaOptions"
                :key="index"
            >
                <b-col md="1">
                    <label class="mt-2">{{ option }}</label>
                </b-col>
                <b-col md="2">
                    <eb-select
                        disabled
                        type="text"
                        label="text"
                        placeholder="Select Option"
                        :options="operatorOptions"
                        v-model="selectedOperator"
                        :selected="selectedOperator[index]"
                    >
                    </eb-select>
                </b-col>
                <b-col md="5">
                    <b-form-input
                        readonly
                        v-if="option !== 'Age' && option !== 'Date'"
                        v-model="inputData[index].value"
                    >
                    </b-form-input>

                    <b-row class="age-row-padding" v-if="option === 'Age'">
                        <b-col class="age-col-no-padding" md="5">
                            <p>{{ inputData[index].value.gte }}</p>
                        </b-col>
                        <b-col class="age-col-center" md="4">
                            <label>Select Age</label>
                        </b-col>
                        <b-col class="age-col-no-padding" md="3">
                            <p class="age-value-right">
                                {{ inputData[index].value.lte }}
                            </p>
                        </b-col>
                        <b-form-input
                            disabled
                            type="range"
                            min="0"
                            :max="max"
                            v-model="inputData[index].value"
                        ></b-form-input>
                    </b-row>

                    <b-row v-if="option === 'Date'">
                        <b-col>
                            <b-row>
                                <b-col md="6">
                                    <b-input
                                        disabled
                                        id="start-date"
                                        type="date"
                                        v-model="
                                            inputData[index].value.startDate
                                        "
                                    ></b-input>
                                </b-col>
                                <b-col md="6">
                                    <b-input
                                        disabled
                                        id="end-date"
                                        type="date"
                                        v-model="inputData[index].value.endDate"
                                    ></b-input>
                                </b-col>
                                <!-- <b-col md="4">
                  <b-button
                    disabled
                    block
                    :pressed.sync="myToggle"
                    size="sm"
                    variant="success"
                    class="form-control"
                    >Confirm Date</b-button
                  >
                </b-col> -->
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>

            <!-- <b-row class="justify-content-md-center my-2">
        <b-button disabled variant="primary" class="w-25"
          >VIEW IMPACTED CUSTOMER</b-button
        >
      </b-row> -->
        </b-card>

        <b-row class="my-2 impacted-buttons-row">
            <b-col cols="12" sm="6" md="6" class="mb-2 mb-sm-0">
                <b-button variant="success" class="btn-rounded-impacted w-100"
                    >Impacted Customer ({{ getDataCriteriaById.count || 0 }})
                    <span class="ml-3 mr-1">
                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                    </span>
                </b-button>
            </b-col>
            <b-col cols="12" sm="6" md="6">
                <b-button
                    @click="downloadDetails"
                    variant="outline-primary"
                    class="download-btn-right w-100"
                >
                    <i class="fa fa-file-text-o mx-2" aria-hidden="true"></i
                    >Download
                </b-button>
            </b-col>
        </b-row>
        <b-card>
            <h4 class="text-primary section-title">
                Notification Configuration
            </h4>
            <b-row>
                <b-col>
                    <eb-select
                        v-if="getDataTemplateById.message"
                        :disabled="
                            getDataCriteriaById.count == '' ||
                            getDataCriteriaById.notificatonStatus ==
                                'COMPLETED' ||
                            getDataCriteriaById.status == 'PENDING'
                        "
                        type="text"
                        label="text"
                        placeholder="Type of Notification"
                        :options="typeOfNotificationOption"
                        v-model="notificationOption"
                        :selected="notificationOption.text"
                        @input="templateTypeList"
                    ></eb-select>
                    <eb-select
                        v-else-if="getDataTemplateById.status === 1"
                        :disabled="
                            getDataCriteriaById.count == '' ||
                            getDataCriteriaById.notificatonStatus ==
                                'COMPLETED' ||
                            getDataCriteriaById.status == 'PENDING'
                        "
                        type="text"
                        label="text"
                        placeholder="Type of Notification"
                        v-model="getDataTemplateById.data.template.name"
                        :selected="getDataTemplateById.data.template.name"
                        @input="templateTypeList"
                    ></eb-select>
                </b-col>
                <b-col>
                    <eb-select
                        v-if="getDataTemplateById.message"
                        :disabled="
                            getDataCriteriaById.count == '' ||
                            getDataCriteriaById.notificatonStatus ==
                                'COMPLETED' ||
                            getDataCriteriaById.status == 'PENDING'
                        "
                        type="text"
                        label="text"
                        placeholder="Template"
                        :options="templateOptionList"
                        v-model="templateOption"
                        :selected="templateOption.text"
                        @input="previewSelectedTemplate"
                    >
                    </eb-select>
                    <eb-select
                        v-else-if="getDataTemplateById.status === 1"
                        :disabled="
                            getDataCriteriaById.count == '' ||
                            getDataCriteriaById.notificatonStatus ==
                                'COMPLETED' ||
                            getDataCriteriaById.status == 'PENDING'
                        "
                        type="text"
                        label="text"
                        placeholder="Template"
                        :options="templateOptionList"
                        v-model="getDataTemplateById.data.template.concern"
                        :selected="getDataTemplateById.data.template.concern"
                        @input="previewSelectedTemplate"
                    >
                    </eb-select>
                </b-col>
            </b-row>
            <b-row>
                <div
                    v-if="getDataTemplateById.message"
                    disabled
                    contentEditable="false"
                    placeholder="Preview Template"
                    class="mb-3 pr-3 previewTemplate"
                    v-html="showPreviewHere"
                ></div>
                <div
                    v-else-if="getDataTemplateById.status === 1"
                    disabled
                    contentEditable="false"
                    placeholder="Preview Template"
                    class="mb-3 pr-3 previewTemplate"
                    v-html="getDataTemplateById.data.template.body"
                ></div>
            </b-row>
            <b-row>
                <b-col cols="12" md="6" class="mb-2">
                    <b-form-input
                        v-if="getDataTemplateById.message"
                        :disabled="
                            getDataCriteriaById.count == '' ||
                            getDataCriteriaById.notificatonStatus ==
                                'COMPLETED' ||
                            getDataCriteriaById.status == 'PENDING'
                        "
                        placeholder="Description"
                        v-model="description"
                    ></b-form-input>
                    <b-form-input
                        v-else-if="getDataTemplateById.status === 1"
                        :disabled="
                            getDataCriteriaById.count == '' ||
                            getDataCriteriaById.notificatonStatus ==
                                'COMPLETED' ||
                            getDataCriteriaById.status == 'PENDING'
                        "
                        placeholder="Description"
                        v-model="getDataTemplateById.data.description"
                    ></b-form-input>
                </b-col>
                <b-col cols="12" md="2" class="mb-2">
                    <b-input
                        disabled
                        type="text"
                        label="label"
                        placeholder="Choose Effective Timestamp"
                    ></b-input>
                </b-col>
                <b-col cols="12" md="2" class="mb-2">
                    <b-input
                        v-if="getDataTemplateById.message"
                        :disabled="
                            getDataCriteriaById.count == '' ||
                            getDataCriteriaById.notificatonStatus ==
                                'COMPLETED' ||
                            getDataCriteriaById.status == 'PENDING'
                        "
                        id="time-stamp"
                        type="date"
                        v-model="timestampDate"
                    ></b-input>
                    <b-input
                        v-else-if="getDataTemplateById.status === 1"
                        :disabled="
                            getDataCriteriaById.count == '' ||
                            getDataCriteriaById.notificatonStatus ==
                                'COMPLETED' ||
                            getDataCriteriaById.status == 'PENDING'
                        "
                        id="time-stamp"
                        type="date"
                        v-model="scheudleDateTime"
                        :selected="scheudleDateTime"
                    ></b-input>
                </b-col>
                <b-col md="2">
                    <b-input
                        v-if="getDataTemplateById.message"
                        :disabled="
                            getDataCriteriaById.count == '' ||
                            getDataCriteriaById.notificatonStatus ==
                                'COMPLETED' ||
                            getDataCriteriaById.status == 'PENDING'
                        "
                        id="time-stamp"
                        type="time"
                        v-model="timestampTime"
                    ></b-input>
                    <b-input
                        v-else-if="getDataTemplateById.status === 1"
                        :disabled="
                            getDataCriteriaById.count == '' ||
                            getDataCriteriaById.notificatonStatus ==
                                'COMPLETED' ||
                            getDataCriteriaById.status == 'PENDING'
                        "
                        id="time-stamp"
                        type="time"
                        v-model="scheudleTimeDate"
                        :selected="scheudleTimeDate"
                    ></b-input>
                </b-col>
            </b-row>

            <b-row class="my-2 justify-content-center">
                <b-col cols="12" class="text-center">
                    <b-button
                        :hidden="
                            getDataCriteriaById.count == '' ||
                            getDataCriteriaById.notificatonStatus ==
                                'COMPLETED' ||
                            getDataCriteriaById.status == 'PENDING'
                        "
                        variant="primary"
                        @click="createBulkNotification"
                    >
                        SUBMIT
                    </b-button>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import moment from "moment";
import ebSelect from "@/components/FormElements/Select.vue";
import evSelect from "@/components/FormElements/Multiselect.vue";
import ebButton from "@/components/FormElements/Button";
import { mapGetters } from "vuex";
export default {
    components: { ebSelect, evSelect, ebButton },
    data() {
        return {
            previewScreen: "",
            description: "",
            myToggle: false,
            rangeValue: 18,
            max: 100,
            startDate: "",
            endDate: "",
            startEndDate: "",
            criteriaOptions: [],
            operatorOptions: [],
            criteria: [],
            typeOfNotificationOption: [
                {
                    text: "Email",
                    value: "EMAIL",
                },
                {
                    text: "Inapp",
                    value: "FCM",
                },
                {
                    text: "Sms",
                    value: "SMS",
                },
                {
                    text: "Whatsapp",
                    value: "WHATSAPP",
                },
            ],
            notificationOption: [],
            templateOption: [],
            showPreviewHere: "",
            timestampDate: "",
            timestampTime: "",
        };
    },

    computed: {
        ...mapGetters({
            getTemplateTypeList: "bulkNotification/GetTemplateTypeList",
            getPreviewTemplate: "bulkNotification/GetPreviewTemplate",
            getDataCriteriaById: "bulkNotification/GetDataCriteriaById",
            getDataTemplateById: "bulkNotification/GetDataTemplateById",
        }),
        templateOptionList() {
            const selectTemplate = this.getTemplateTypeList.map((template) => ({
                text: template.concern,
                value: template?._id || "",
            }));
            return selectTemplate;
        },

        selectedCriteriaOptions() {
            const selectedOptions = this.getDataCriteriaById?.filterBy?.map(
                (selectedOption) => {
                    let result = selectedOption.field.replace(
                        /([A-Z])/g,
                        " $1",
                    );
                    let textValue =
                        result.charAt(0).toUpperCase() + result.slice(1);
                    return textValue;
                },
            );
            return selectedOptions;
        },

        selectedOperator() {
            const selectedOptions = this.getDataCriteriaById?.filterBy?.map(
                (selectedOption) => {
                    let result = selectedOption.filter.replace(
                        /([A-Z])/g,
                        " $1",
                    );
                    let operatorText =
                        result.charAt(0).toUpperCase() + result.slice(1);
                    return operatorText;
                },
            );
            return selectedOptions;
        },

        inputData() {
            const inputEntered = this.getDataCriteriaById?.filterBy?.map(
                (criteriaData) => {
                    if (criteriaData.data.value) {
                        let enteredData = {
                            value: criteriaData.data.value,
                        };
                        return enteredData;
                    } else {
                        let enteredData = {
                            value: {
                                startDate: criteriaData.data.gte,
                                endDate: criteriaData.data.lte,
                            },
                        };
                        return enteredData;
                    }
                },
            );
            return inputEntered;
        },

        scheudleDateTime() {
            let scheduleDate =
                this.getDataTemplateById.data.scheduleDate.split("T");
            return scheduleDate[0];
        },
        scheudleTimeDate() {
            let scheduleTime =
                this.getDataTemplateById.data.scheduleDate.split("T");
            let timeSchedule = scheduleTime[1].split(".");
            return timeSchedule[0];
        },
    },

    methods: {
        downloadDetails() {
            if (this.getDataCriteriaById.status === "PENDING") {
                this.$swal({
                    title: "Info",
                    text: "Fetching Customer List. Please Wait...",
                    type: "info",
                });
            } else if (
                this.getDataCriteriaById.count &&
                this.getDataCriteriaById.count !== 0
            ) {
                window.location = this.getDataCriteriaById.url;
            } else {
                this.$swal({
                    title: "Error",
                    text: "Data Not Available.",
                    type: "error",
                });
            }
        },

        async templateTypeList() {
            this.templateOption = "";
            let payload = {
                service: this.notificationOption?.value || "",
            };
            await this.$store.dispatch(
                "bulkNotification/fetchTemplateTypeList",
                payload,
            );
        },

        async previewSelectedTemplate() {
            let payload = {
                templateId: this.templateOption.value,
            };
            await this.$store.dispatch(
                "bulkNotification/fetchTemplateToPreview",
                payload,
            );
            this.showPreviewHere = this.showPreview()
                .map((pre) => pre.body)
                .join("")
                .toString();
        },

        showPreview() {
            const previewTemplate = this.getPreviewTemplate.map((preview) => ({
                body: preview?.body || "",
            }));
            return previewTemplate;
        },

        async createBulkNotification() {
            if (this.getDataCriteriaById.count !== 0) {
                if (
                    this.notificationOption.value &&
                    this.templateOption.value
                ) {
                    const payload = {
                        criteria: { ...this.getDataCriteriaById },
                        notificationType: this.notificationOption.value,
                        template: {
                            _id: this.getPreviewTemplate[0]._id,
                            name: this.getPreviewTemplate[0].service,
                            concern: this.getPreviewTemplate[0].concern,
                            body: this.getPreviewTemplate[0].body,
                            image: this.getPreviewTemplate[0].image,
                        },
                        description: this.description,
                        scheduleDate: "",
                    };
                    await this.$store
                        .dispatch(
                            "bulkNotification/createBulkNotification",
                            payload,
                        )
                        .then((result) => {
                            this.$swal({
                                title: "Successful",
                                text: "Bulk notification Created Successfully!",
                                type: "success",
                            });
                            this.$router.push("/listOfCriteria");
                        })
                        .catch((err) => {
                            this.$swal({
                                title: "Sorry",
                                text: "Unable to Create bulk Notification",
                                type: "error",
                            });
                        });
                } else {
                    this.$swal({
                        title: "Error",
                        text: "Select All Fields",
                        type: "error",
                    });
                }
            } else {
                this.$swal({
                    title: "Error",
                    text: "No Impacted Customer Available",
                    type: "error",
                });
            }
        },
    },

    async mounted() {
        this.loading = true;
        let payload = { label: "CUSTOMER" };
        await this.$store.dispatch("bulkNotification/fetchEntities", payload);
        let payload1 = { id: this.$route.params.id };
        await this.$store.dispatch(
            "bulkNotification/fetchDetailsCriteriaById",
            payload1,
        );
        await this.$store.dispatch(
            "bulkNotification/fetchDetailsTemplateById",
            payload1,
        );
        if (this.getDataCriteriaById.status === "PENDING") {
            this.$swal({
                title: "Info",
                text: "Fetching Customer List. Please Wait...",
                type: "info",
            });
        }
        this.loading = false;
    },
};
</script>
<style>
.previewTemplate {
    margin: 0px 15px;
    height: auto;
    max-height: 180px;
    padding: 12px;
    border: 1px solid rgb(228, 214, 214);
    border-radius: 4px;
    min-width: 92%;

    overflow: auto;
}

.previewTemplate[contentEditable="false"]:empty:before {
    content: attr(placeholder);
}

.form-control {
    height: calc(2.2125rem + 8px);
}

.back-btn-right {
    float: right;
}

.select-background-white {
    background-color: #fff;
}

.age-row-padding {
    padding: 0px 20px;
}

.age-col-no-padding {
    padding: 0px;
}

.age-col-center {
    padding: 0px 20px;
}

.age-value-right {
    float: right;
}

.btn-rounded-impacted {
    border-radius: 18px;
}

.download-btn-right {
    float: right;
}

.impacted-buttons-row {
    align-items: center;
}

.page-title {
    font-size: 1.5rem;
    margin-bottom: 1rem;
}

.section-title {
    font-size: 1.125rem;
    margin-bottom: 1rem;
}

@media (max-width: 767.98px) {
    .page-title {
        font-size: 1.25rem;
    }

    .section-title {
        font-size: 1rem;
    }

    .back-btn-right {
        float: right;
        width: 120px;
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        margin-top: 0.5rem;
        margin-bottom: 5px;
    }

    .age-row-padding {
        padding: 0px 10px;
    }

    .age-col-center {
        padding: 0px 10px;
    }

    .age-value-right {
        float: none;
        text-align: left;
    }

    .download-btn-right {
        float: none;
        width: 100%;
        margin-top: 0;
    }
}

@media (max-width: 575.98px) {
    .page-title {
        font-size: 1.125rem;
    }

    .section-title {
        font-size: 0.95rem;
    }
}
</style>
